import React from 'react';
import {
  Dialog, DialogContent, Box, Typography, IconButton,
  useTheme, useMediaQuery,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import RegisterConsultForm from './RegisterConsultForm';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';

const RegisterConsultDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" fullScreen={fullScreen}>
      {/* هدر دیالوگ */}
      <Box sx={{
        background: GRADIENT, color: 'white', px: 2, py: 1.5,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          ثبت‌نام و مشاوره
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ pt: 2 }}>
        {/* با هر بار باز شدن، فرم تازه mount می‌شود و state ریست است */}
        {open && <RegisterConsultForm onCancel={onClose} />}
      </DialogContent>
    </Dialog>
  );
};

export default RegisterConsultDialog;